/*
Color Mapping Helpers for Publishing Forms
Author: Assistant
Date: 2025-01-21
*/

import { mapColorTypeToPlatform } from './strictValidationMappings'

export const findMatchingApiColor = (
  userColor: string,
  apiOptions: string[],
  platform: 'chileautos' | 'mercadolibre' | 'yapo'
): string | null => {
  if (!userColor || !apiOptions || apiOptions.length === 0) {
    return null
  }

  // Try exact match first
  if (apiOptions.includes(userColor)) {
    return userColor
  }

  // Try platform-specific mapping
  try {
    const platformColor = mapColorTypeToPlatform(userColor, platform)

    if (platformColor && apiOptions.includes(platformColor)) {
      return platformColor
    }
  } catch (error) {
    console.warn(`Error mapping color ${userColor} to platform ${platform}:`, error)
  }

  // Handle "Plata / Plateado" special case
  const userColorLower = userColor.toLowerCase()

  if (userColorLower.includes('plata')) {
    const plataOptions = apiOptions.filter(
      (option) => option.toLowerCase().includes('plata') || option.toLowerCase().includes('plateado')
    )

    if (plataOptions.length > 0) {
      return plataOptions[0]
    }
  }

  console.warn(`No matching API color found for "${userColor}" in options:`, apiOptions)

  return null
}

export const autoSelectColor = (
  vehicleColor: string,
  apiColors: string[],
  platform: 'chileautos' | 'mercadolibre' | 'yapo'
) => {
  const matchingColor = findMatchingApiColor(vehicleColor, apiColors, platform)

  return {
    selectedColor: matchingColor,
    isMatched: !!matchingColor,
    originalColor: vehicleColor,
  }
}
